import { Box, Select } from '@primer/react';
import { useSelector } from 'react-redux';
import { useCommonContext } from '../../contexts/common';
import { RootState } from '../../state/reducers';
import styles from "./CoboboxDiemDanhStatus.module.css";
import React, { useEffect } from 'react';
import { diemDanhStatusApi } from '../../api/diemDanhStatusApi';
import { useTrangThaiDiemDanh } from '../../hooks/useTrangThaiDiemDanh';
interface ISelectBoxItemData {
	id: number,
	name: string,
	name_en: string,
	is_default: boolean,
}
type ComboBoxDiemDanhStatusProps = {
	isReadonly?: boolean;
	value?: number;
	onValueChanged: (id: number, data?: ISelectBoxItemData) => void;
	className?: string;
	isShowClearButton?: boolean;
	preText?: string;
	width?: string | number;
	stylingMode?: 'outlined' | 'filled' | 'underlined';
	isNoborder?: boolean
};

const ComboBoxDiemDanhStatus = (props: ComboBoxDiemDanhStatusProps) => {
	const { translate } = useCommonContext();
	const { language } = useSelector((x: RootState) => x.common);
	const { nt_diem_danh_trang_thais } = useTrangThaiDiemDanh();

	return (
		<Box className={props.isNoborder ? styles.noborder : ""}>
			<Select size="small" onChange={(e) => {
				const id: number = e.currentTarget.value ? parseInt(e.currentTarget.value) : 0
				props.onValueChanged(id, nt_diem_danh_trang_thais.find(x => x.id === id))
			}}>
				{nt_diem_danh_trang_thais.map(x => {
					console.log('value', nt_diem_danh_trang_thais);
					return (
						<Select.Option value={x.id.toString()}
							selected={x.id === props.value}
						>{language === "en" ? x.name_en : x.name}</Select.Option>
					);
				})}
			</Select>
		</Box>
		
	);
};

export default ComboBoxDiemDanhStatus;
